import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import {
    createFieldCheckbox,
    createFieldInputNumber,
    createFieldSelect,
    createFieldTemplateBuilder
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";

const HazAquaticList = defineAsyncComponent(() => import("./HazAquaticList"));

export const callLd50 = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/ld50/cacheFindAll", { where: [{ name: "nameTh", operator: "like", value: searchQuery }] });
export const callOperator = ({ searchQuery }) => ["=", "!=", ">", "<", ">=", "<="].filter(d => d.includes(searchQuery || ""));
export const callPictogram = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/pictogram/cacheFindAll", { where: [{ name: "name", operator: "like", value: searchQuery }] });

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div class="text-bold text-16">{i18n.global.t("views.request.hazPictogram.label")}</div>
            },
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => {
                    /* 
                    createFieldCheckbox({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                key: `${prefix}isSolid`,
                                colProp: () => ({ xs: 12 }),
                                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                label: () => i18n.global.t("model.haz.isSolid"),
                                labelRender: () => "",
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            checked: model.isSolid,
                                            "onUpdate:checked": checked => {
                                                model.isSolid = checked;
                                                if (checked) {
                                                    model.isLiquid = false;
                                                    model.liquid = null;
                                                }
                                            },
                                            disabled: viewOnly,
                                            text: () => i18n.global.t("model.haz.isSolid")
                                        },
                                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                    )
                            })
                    */
                    const fields = data.pictograms.map((pictogram, index) =>
                        createFieldCheckbox({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}pictograms.${index}.refPictogram`,
                            colProp: () => ({ xs: 8 }),
                            formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                            label: () => pictogram.name,
                            labelRender: () => "",
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        checked: !!model.pictograms.filter(d => d.isDelete !== true).find(d => d.refPictogram?.id === pictogram.id),
                                        "onUpdate:checked": checked => {
                                            const valueIndex = model.pictograms.findIndex(d => d.refPictogram?.id === pictogram.id);
                                            const value = model.pictograms.find(d => d.refPictogram?.id === pictogram.id);
                                            if (checked) {
                                                if (value) {
                                                    value.isSave = true;
                                                    value.isDelete = false;
                                                } else {
                                                    model.pictograms.push({ refPictogram: pictogram });
                                                }
                                            } else {
                                                if (value.id) {
                                                    value.isSave = false;
                                                    value.isDelete = true;
                                                } else {
                                                    model.pictograms.splice(valueIndex, 1);
                                                }
                                            }
                                        },
                                        disabled: viewOnly,
                                        text: () => pictogram.name
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    );
                    fields.push({
                        visible: () => data.useForm.validateInfos[`${prefix}pictograms`]?.validateStatus === "error",
                        colProp: () => ({ xs: 24 }),
                        formItemRender: () => (
                            <div class="has-error">
                                <div class="ant-form-explain">{data.useForm.validateInfos[`${prefix}pictograms`]?.help}</div>
                            </div>
                        )
                    });
                    return { useForm, fields, skeleton: isLoading.value };
                }
            }),
            {
                visible: () => true,
                key: `${prefix}ld50ValueLabel`,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div class="text-bold text-16"><hr/>{i18n.global.t("views.request.ld50Value.label")}</div>
            },
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ld50Value`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.haz.ld50Value"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ld50Value,
                            "onUpdate:value": value => (model.ld50Value = value),
                            disabled: viewOnly,
                            addonAfter: () => <div>mg/kg</div>
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refLd50`,
                colProp: () => ({ xs: 24, md: 4 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refLd50"),
                labelRender: () => "",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refLd50,
                            "onUpdate:value": value => (model.refLd50 = value),
                            disabled: true,
                            list: callLd50,
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ld50Operator`,
                colProp: () => ({ xs: 24, md: 4 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                label: () => i18n.global.t("model.haz.ld50Operator"),
                labelRender: () => "",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ld50Operator,
                            "onUpdate:value": value => (model.ld50Operator = value),
                            disabled: true,
                            list: callOperator,
                            optKey: "",
                            optLabel: "",
                            placeholder: ""
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemRender: () => <div class="text-bold text-16"><hr/>{i18n.global.t("model.hazAquatic.modelName")}</div>
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}aquatics`,
                            fetchCriteria: data.aquatic?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "HazAquaticList" } })
                    );
                    return <HazAquaticList {...componentProp}></HazAquaticList>;
                }
            }
        ]
    });
};
